import { Typography } from '@mui/material'

export interface HeatDetectionMethod {
  status: string
  text: string
}

export interface TypeHeatDetectionMethodProps {
  value?: HeatDetectionMethod | null
}

export const TypeHeatDetectionMethod = ({ value }: TypeHeatDetectionMethodProps) => {
  if (!value?.text) {
    return '-'
  }

  return <Typography>{value.text}</Typography>
}
